import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Cronograma() {
  const cronograma = [
    {
      semana: "Semana 1",
      periodo: "19/04/2025 a 25/04/2025",
      atividade:
        "Planeamento geral do sistema, estrutura do banco de dados, arquitetura de pastas, configuração do ambiente de desenvolvimento e controle de versão.",
      reuniao: "Saturday, 19/04/2025",
    },
    {
      semana: "Semana 2",
      periodo: "26/04/2025 a 02/05/2025",
      atividade:
        "Desenvolvimento do módulo de colaboradores: formulários de registo, uploads de documentos, filtros e página de listagem.",
      reuniao: "Saturday, 26/04/2025",
    },
    {
      semana: "Semana 3",
      periodo: "03/05/2025 a 09/05/2025",
      atividade:
        "Desenvolvimento do módulo de clientes e projetos: criação, edição e vinculação entre projetos, clientes e colaboradores.",
      reuniao: "Saturday, 03/05/2025",
    },
    {
      semana: "Semana 4",
      periodo: "10/05/2025 a 16/05/2025",
      atividade:
        "Implementação do módulo de certificações: registo de tipos e níveis, upload de certificados, alertas e filtros personalizados.",
      reuniao: "Saturday, 10/05/2025",
    },
    {
      semana: "Semana 5",
      periodo: "17/05/2025 a 23/05/2025",
      atividade:
        "Módulo de contratos e atividades marítimas: registo de contratos, entradas e saídas (crew change), validação de repouso legal.",
      reuniao: "Saturday, 17/05/2025",
    },
    {
      semana: "Semana 6",
      periodo: "24/05/2025 a 30/05/2025",
      atividade:
        "Módulo de registo de férias, inabilitações, controle de operações do sistema e gestão de logs.",
      reuniao: "Saturday, 24/05/2025",
    },
    {
      semana: "Semana 7",
      periodo: "31/05/2025 a 06/06/2025",
      atividade:
        "Dashboard estatístico: gráficos, KPIs, filtros analíticos, listagens segmentadas.",
      reuniao: "Saturday, 31/05/2025",
    },
    {
      semana: "Semana 8",
      periodo: "07/06/2025 a 13/06/2025",
      atividade:
        "Testes gerais de usabilidade, validação funcional, correção de bugs, ajustes visuais e otimização de desempenho.",
      reuniao: "Saturday, 07/06/2025",
    },
    {
      semana: "Semana 9",
      periodo: "14/06/2025 a 20/06/2025",
      atividade:
        "Deploy final em ambiente online, verificação de segurança, documentação de entrega e preparação para apresentação final ao cliente.",
      reuniao: "Saturday, 14/06/2025",
    },
  ];

  return (
    <div style={{ backgroundColor: "#0a0a5e", minHeight: "100vh", padding: "40px 20px" }}>
      <div
        style={{
          maxWidth: "90%",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "20px",
          padding: "30px",
          color: "#0a0a5e",
          boxShadow: "0 0 30px rgba(0,0,0,0.2)",
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
          Cronograma de Desenvolvimento – RCA
        </h1>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#28ace3", color: "white" }}>
                <th style={cellStyle}>Semana</th>
                <th style={cellStyle}>Período</th>
                <th style={cellStyle}>Atividades Planeadas</th>
                <th style={cellStyle}>Reunião de Feedback</th>
              </tr>
            </thead>
            <tbody>
              {cronograma.map((item, idx) => (
                <tr
                  key={idx}
                  style={{ backgroundColor: idx % 2 === 0 ? "#f3f9fc" : "#ffffff" }}
                >
                  <td style={cellStyle}>{item.semana}</td>
                  <td style={cellStyle}>{item.periodo}</td>
                  <td style={cellStyle}>{item.atividade}</td>
                  <td style={cellStyle}>{item.reuniao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const cellStyle = {
  padding: "12px 16px",
  border: "1px solid #ddd",
  verticalAlign: "top",
};
